<template>
<!-- 用户协议及隐私条例 -->
<div class="privacy-wrap">
    <a-card title="用户协议与隐私政策" style="width:98%;">
        <p>本应用尊重并保护所有使用服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，本应用会按照本隐私权政策的规定使用和披露您的个人信息。但本应用将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，本应用不会将这些信息对外披露或向第三方提供。本应用会不时更新本隐私权政策。</p>
        <p>您在同意本应用服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于本应用服务使用协议不可分割的一部分。</p>
        <p>1. 适用范围</p>
        <p>(i) 在您使用本应用网络服务，或访问本应用平台网页时，本应用自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；您了解并同意，以下信息不适用本隐私权政策：</p>
        <p>(ii) 本应用收集到的您在本应用发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>
    </a-card>
</div>
</template>
<script>
  import { onMounted } from 'vue'
  export default {
    name: 'Privacy',
    
    setup() {
       
        onMounted(() => {
            console.log("privacy mounted!")
        })

        return {}
    }
  };
</script>
<style lang="scss" scoped>
.privacy-wrap {
    background:#fff;
    width:100%;
    font-size:12px;
    text-align:center;
    display:block;
    max-height: 500px;
    overflow-y: scroll;
     p {text-align:left;}
 }
</style>